import React, { Component } from 'react';
import { connect } from 'react-redux';

// Decorators
import { getCMSUrlCheckIn } from '../../constants/cms-urls';
import { retriveActualHostUrl, setTabIndex } from '../../utilities/helpers';

// Components
import TranslatedCopy from '../../intl/translated-copy';
import LoadingComponent from './loading-component';

const mapStateToProps = state => ({
  isSignIn: state.UserProfileSession.isSignIn,
  language: state.Manage.language,
  storefront : state.Manage.storefront,
  userProfile: state.UserProfileSession.userProfile,
  userToken: state.UserProfileSession.userToken,
});

class LoggedBar extends Component {
  constructor() {
    super();
  }

  render() {
    const { isCheckin, isSignIn, moreThanOneTrip, noTrips, trip  } = this.props;
    let cityPair = [];
    let iconFlightType = '';

    if ( isSignIn && trip && trip.bookedLegCollection ) {
      cityPair = this.getLegCityPair(trip.bookedLegCollection._collection[0].segments._collection);
      iconFlightType = trip.tripType === 'Multi-City' ? 'arrowMultiTrip' : trip.tripType === 'Round-Trip' ? 'arrowReturnTrip' : 'arrowSingleTrip';
    }

    return (
      <div className='LoggedBar-main'>
        {
          isCheckin 
            ? this.bannerIsCheckin(cityPair, iconFlightType, trip)
            : moreThanOneTrip
              ? this.bannerMoreThanOneTrip() 
              : noTrips 
                ? this.bannerNoTrips()
                : this.bannerLoading()
        }
      </div>
    );
  }

  getLegCityPair(trip) {
    const departureAirport = trip[0].segment.departureAirport;
    const arrivalAirport = trip[trip.length - 1].segment.arrivalAirport;

    return [departureAirport, arrivalAirport];
  }

  bannerIsCheckin(cityPair, iconFlightType, trip) {
    const { isSignIn } = this.props;

    return (
      <div className={`${isSignIn && 'isSignedIn'} LoggedBar-container`}>
        <span className='Icon Icon--handDocument' />
        <div className='LoggedBar-text'>
          <span className='LoggedBar-text-bold'>
            <TranslatedCopy
              copyID= { 'LGN_BANNER_CHKN_1' }
              spaceAfter={ true }
            />
            <span className='LoggedBar-text-margin-left'>
              { cityPair[0] } <span className={`Icon Icon--${iconFlightType}`} /> { cityPair[1] }.
            </span>
          </span>
          <TranslatedCopy
            copyID= { 'LGN_BANNER_CHKN_2' }
            spaceBefore={ true }
            spaceAfter={ true }
          />
          <button className= 'Link LoggedBar-bannerIsCheckin' onClick={ () => this.handleLinksOptions('CHECK_IN_BANNER', trip.reservationCode, trip.lastName) }> 
            <TranslatedCopy
              copyID= { 'LGN_BANNER_IR_CHKN' }
              spaceBefore={ true }
            />
          </button>
        </div>
      </div>
    );
  }

  bannerMoreThanOneTrip() {
    const { isSignIn } = this.props;

    return (
      <div className={`${isSignIn && 'isSignedIn'} LoggedBar-container`}>
        <span className='Icon Icon--suitcaseTwo' />
        <div className='LoggedBar-text'>
          <span>
            <TranslatedCopy
              copyID= { 'LGN_BANNER_MAS_VIAJES' }
              spaceBefore={ true }
            />
          </span>
          <a 
            className='Link LoggedBar-text-margin-left--trips'
            onClick={ ( e ) => this.redirectProfileEFour( e, 0 ) }
          >
            <TranslatedCopy copyID= { 'LGN_BANNER_IR_VIAJES' } />
          </a>
        </div>
      </div>
    );
  }

  bannerNoTrips() {
    const { isSignIn } = this.props;

    return (
      <div className={`${isSignIn && 'isSignedIn'} LoggedBar-container`}>
        <span className='Icon Icon--planeAlt' />
        <div className='LoggedBar-text'>
          <span>
            <TranslatedCopy
              copyID= 'LGN_BANNER_NO_VIAJES'
              spaceBefore={ true }
              spaceAfter={ true }
            />
          </span>
          <a 
            className='Link LoggedBar-text-margin-left--trips'
            onClick={ ( e ) => this.redirectProfileEFour( e, 0 ) }
          >
            <TranslatedCopy copyID= { 'LGN_BANNER_IR_VIAJES' } />
          </a>
        </div>
      </div>
    );
  }

  bannerLoading() {
    const { isSignIn } = this.props;

    return (
      <div className={`${isSignIn && 'isSignedIn'} LoggedBar-container LoggedBar-container--loading`}>
        <LoadingComponent />
      </div>
    );
  }

  handleLinksOptions(typeLink, pnrCode, lastName) {
    const { language, storefront } = this.props;
    const urlCheckIn = getCMSUrlCheckIn(storefront, language, typeLink, pnrCode, lastName);

    window.location.replace(urlCheckIn);
  }

  redirectProfileEFour = ( e, tabIndex ) => {
    const { language, storefront } = this.props;

    setTabIndex(tabIndex);
    const redirectHost = window.location.host;
    e.preventDefault();
    retriveActualHostUrl(redirectHost, language, storefront);
  }
}

LoggedBar = connect(mapStateToProps)(LoggedBar);

export default LoggedBar;
